/*
  Book an appointment overlay (sections/booking-overlay.liquid).

  REQUIREMENTS, Clinic / booking, "Booking journeys and tracking, 2 Oct":

  1. Interception by URL, not by template. A click on a link whose label is
     Book, Book now, Book a treatment or Book this treatment, and whose
     address is /pages/book-a-treatment, /pages/book-a-treatment-london,
     /pages/book-now or a Pabau online-bookings page, opens the overlay
     instead. The link's own address stays as the no-script destination.
  2. Context: the treatment and clinic come from the button (treatment and
     clinic cards carry data-book-* attributes) and then from the page
     (window.DDJTracking.context, snippets/booking-context.liquid). A Pabau
     link on the button, the treatment or the clinic becomes Book a clinic
     treatment's destination; a drdavidjack.com link counts as none.
  3. Machine treatments hide Book a clinic treatment.
  4. A link carrying ?route=clinic_consultation (or clinic_treatment,
     virtual, enquiry) on a booking page address skips the overlay: it is
     pointed straight at that route's destination when the page loads (the
     skin consultation page's Book buttons).

  Tracking (assets/tracking.js): booking_cta_click and booking_overlay_open
  on open, booking_route_select on a route. The click out to Pabau
  (pabau_online_booking_visit, campaign tags, the route kept for the visit)
  is tracking.js's own Pabau link handler, which reads the data-booking-*
  attributes set here.
*/
(function () {
  /* Page scroll lock, shared with the other overlays (assets/scroll-lock.js). */
  function lockPage(on) {
    if (window.DDJScrollLock) window.DDJScrollLock.set('booking', on);
    else document.body.style.overflow = on ? 'hidden' : '';
  }

  if (window.DDJBooking) return;

  var BOOK_LABELS = { 'book': 1, 'book now': 1, 'book a treatment': 1, 'book this treatment': 1 };
  var BOOK_PATHS = ['/pages/book-a-treatment', '/pages/book-a-treatment-london', '/pages/book-now'];
  var ROUTES = { clinic_treatment: 1, clinic_consultation: 1, virtual: 1, enquiry: 1 };

  var root = null;
  var isOpen = false;
  var lastFocused = null;
  var current = null;

  function cfg() { return (window.DDJTracking && window.DDJTracking.context) || {}; }
  function T() { return window.DDJTrack || null; }
  function track(event, params) { var t = T(); if (t) t.track(event, params); }

  function normalise(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isPabau(href) {
    return /(^|\.)pabau\.com\//i.test(String(href || '').replace(/^https?:\/\//i, '')) && /online-bookings/i.test(href);
  }

  function parse(href) {
    try { return new URL(href, window.location.href); } catch (e) { return null; }
  }

  function isBookPath(url) {
    if (!url || url.origin !== window.location.origin) return false;
    var path = url.pathname.replace(/\/+$/, '');
    for (var i = 0; i < BOOK_PATHS.length; i++) {
      var p = BOOK_PATHS[i];
      /* Market sub-folders (/en-ie/pages/...) end the same way. */
      if (path === p || path.slice(-p.length) === p) return true;
    }
    return false;
  }

  /* ─── Destinations ───────────────────────────────────────────────────── */

  function clinicByValue(value) {
    var list = cfg().clinics || [];
    var key = normalise(value);
    for (var i = 0; i < list.length; i++) if (normalise(list[i].value) === key) return list[i];
    return null;
  }

  function clinicByPage(handle) {
    var list = cfg().clinics || [];
    for (var i = 0; i < list.length; i++) if (list[i].page && list[i].page === handle) return list[i];
    return null;
  }

  function portalUrl(category, location) {
    var base = cfg().portal || 'https://partner.pabau.com/online-bookings/dr-david-jack-london-';
    var url = parse(base);
    if (!url) return base;
    if (category) {
      url.searchParams.set('category', category);
      if (location) url.searchParams.set('location', location);
      url.searchParams.set('fallback', 'true');
      url.searchParams.set('serviceType', '0');
    } else if (location) {
      url.searchParams.set('location', location);
    }
    return url.toString();
  }

  /* Put a clinic's location on a Pabau link that has none. */
  function withLocation(href, clinic) {
    if (!clinic || !clinic.location) return href;
    var url = parse(href);
    if (!url || url.searchParams.has('location')) return href;
    url.searchParams.set('location', clinic.location);
    return url.toString();
  }

  function destinations(c) {
    var clinic = c.clinic;
    var treatmentHref;
    if (c.treatmentPabau) treatmentHref = c.treatmentPabau;
    else if (clinic && clinic.category) treatmentHref = portalUrl(clinic.category, clinic.location);
    else if (c.clinicPabau) treatmentHref = withLocation(c.clinicPabau, clinic);
    else if (c.linkPabau) treatmentHref = c.linkPabau;
    else treatmentHref = portalUrl('', clinic ? clinic.location : '');

    var consultationHref;
    if (clinic && clinic.category) consultationHref = portalUrl(clinic.category, clinic.location);
    else consultationHref = portalUrl(cfg().consultations || '', clinic ? clinic.location : '');

    var form = parse(cfg().formPage || '/pages/book-a-treatment-london');
    if (c.treatment) form.searchParams.set('treatment', c.treatment);
    if (clinic) form.searchParams.set('clinic', clinic.value);

    return {
      clinic_treatment: treatmentHref,
      clinic_consultation: consultationHref,
      virtual: cfg().virtualPage || '/pages/virtual-consultation',
      enquiry: form.pathname + form.search
    };
  }

  /* ─── Context: the button first, then the page ───────────────────────── */

  function ctaLocation(link) {
    if (link.closest('[data-sticky-bar]')) return 'sticky';
    if (link.closest('[data-header-drawer]')) return 'menu';
    if (link.closest('.treatment-card')) return link.hasAttribute('data-book-clinic-page') && !link.hasAttribute('data-book-treatment') ? 'clinic_card' : 'treatment_card';
    if (link.closest('[data-header]')) return 'header';
    if (link.closest('.page-header')) return 'page_header';
    return 'page';
  }

  function contextFor(link) {
    var page = cfg();
    var c = { treatment: '', machine: false, treatmentPabau: '', clinic: null, clinicPabau: '', linkPabau: '' };

    if (link.hasAttribute('data-book-treatment')) {
      c.treatment = link.getAttribute('data-book-treatment');
      c.machine = link.getAttribute('data-book-machine') === 'true';
      c.treatmentPabau = link.getAttribute('data-book-pabau') || '';
    } else if (page.treatment && !link.hasAttribute('data-book-clinic-page')) {
      c.treatment = page.treatment.handle;
      c.machine = !!page.treatment.machine;
      c.treatmentPabau = page.treatment.pabau || '';
    }

    if (link.hasAttribute('data-book-clinic-page')) {
      c.clinic = clinicByPage(link.getAttribute('data-book-clinic-page'));
      c.clinicPabau = link.getAttribute('data-book-pabau') || '';
      if (!link.hasAttribute('data-book-treatment')) c.treatmentPabau = '';
    } else if (page.clinic) {
      c.clinic = clinicByValue(page.clinic.value) || page.clinic;
      c.clinicPabau = page.clinic.pabau || '';
    }

    var href = link.href;
    if (isPabau(href)) c.linkPabau = href;
    c.location = ctaLocation(link);
    return c;
  }

  /* ─── The overlay ────────────────────────────────────────────────────── */

  function closeOtherOverlays() {
    var nav = document.querySelector('[data-drawer-toggle][aria-expanded="true"]');
    if (nav) nav.click();
    var search = document.querySelector('[data-search-drawer].is-open [data-search-close]');
    if (search) search.click();
    if (window.DDJCart && typeof window.DDJCart.close === 'function') window.DDJCart.close();
  }

  function focusables() {
    if (!root) return [];
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; }
    );
  }

  function fill(c) {
    var d = destinations(c);
    root.querySelectorAll('[data-booking-row]').forEach(function (row) {
      var route = row.getAttribute('data-booking-row');
      row.hidden = route === 'clinic_treatment' && c.machine;
      var a = row.querySelector('[data-booking-link]');
      if (!a) return;
      a.setAttribute('href', d[route]);
      a.setAttribute('data-booking-location', c.location || 'page');
      if (c.treatment) a.setAttribute('data-booking-treatment', c.treatment);
      else a.removeAttribute('data-booking-treatment');
      if (c.clinic) a.setAttribute('data-booking-clinic', c.clinic.value);
      else a.removeAttribute('data-booking-clinic');
    });
    var scroller = root.querySelector('[data-booking-scroll]');
    if (scroller) scroller.scrollTop = 0;
  }

  function open(c, quiet) {
    if (!root) return;
    current = c;
    fill(c);
    if (!isOpen) {
      closeOtherOverlays();
      lastFocused = document.activeElement;
      isOpen = true;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      lockPage(true);
    }
    var close = root.querySelector('.sheet__panel [data-booking-close]');
    /* Opened from the menu drawer, wait for the drawer to finish closing. */
    var tries = 0;
    (function focusClose() {
      if (!isOpen) return;
      if (close) close.focus();
      if (root.contains(document.activeElement) || tries++ > 30) return;
      setTimeout(focusClose, 50);
    })();

    if (quiet) return;
    var params = { cta_location: c.location, treatment: c.treatment, clinic: c.clinic ? c.clinic.value : '' };
    track('booking_cta_click', params);
    track('booking_overlay_open', params);
  }

  function close() {
    if (!root || !isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    lockPage(false);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { if (!isOpen) root.hidden = true; }, reduce ? 0 : 320);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  /* ─── Clicks ─────────────────────────────────────────────────────────── */

  function shouldIntercept(link) {
    if (!link || link.closest('[data-booking-overlay]')) return false;
    if (link.hasAttribute('data-booking-direct')) return false;
    var label = normalise(link.getAttribute('aria-label') || link.textContent);
    if (!BOOK_LABELS[label]) return false;
    var url = parse(link.getAttribute('href'));
    if (!url) return false;
    if (url.searchParams.has('route')) return false;
    return isBookPath(url) || isPabau(url.href);
  }

  /* Capture phase, so it runs before tracking.js's own link handler. */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    if (root && root.contains(link) && link.hasAttribute('data-booking-link')) {
      track('booking_route_select', {
        route: link.getAttribute('data-booking-route'),
        cta_location: link.getAttribute('data-booking-location'),
        treatment: link.getAttribute('data-booking-treatment'),
        clinic: link.getAttribute('data-booking-clinic')
      });
      return; /* let it navigate; tracking.js handles a Pabau link */
    }

    if (!shouldIntercept(link)) return;
    if (!root) return; /* no overlay on this page: the link works as a link */
    event.preventDefault();
    open(contextFor(link));
  }, true);

  document.addEventListener('click', function (event) {
    if (!isOpen) return;
    if (event.target.closest && event.target.closest('[data-booking-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!isOpen) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (!root.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* Back from Pabau with the browser's back button: the page may come back
   * from the back-forward cache with the overlay still open. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && isOpen) close();
  });

  /* ─── Direct route links ─────────────────────────────────────────────── */

  function pointDirectLinks() {
    var page = cfg();
    var c = {
      treatment: page.treatment ? page.treatment.handle : '',
      machine: false,
      treatmentPabau: page.treatment ? page.treatment.pabau : '',
      clinic: page.clinic ? (clinicByValue(page.clinic.value) || page.clinic) : null,
      clinicPabau: page.clinic ? page.clinic.pabau : '',
      linkPabau: ''
    };
    var d = null;
    document.querySelectorAll('a[href*="route="]').forEach(function (link) {
      if (link.closest('[data-booking-overlay]')) return;
      var url = parse(link.getAttribute('href'));
      if (!url || !isBookPath(url)) return;
      var route = url.searchParams.get('route');
      if (!ROUTES[route]) return;
      d = d || destinations(c);
      link.setAttribute('href', d[route]);
      link.setAttribute('data-booking-direct', '');
      link.setAttribute('data-booking-route', route);
      link.setAttribute('data-booking-location', link.closest('.page-header') ? 'page_header' : 'page');
      if (c.treatment) link.setAttribute('data-booking-treatment', c.treatment);
      if (c.clinic) link.setAttribute('data-booking-clinic', c.clinic.value);
    });
  }

  function init() {
    root = document.querySelector('[data-booking-overlay]');
    pointDirectLinks();
  }

  window.DDJBooking = {
    open: function (opts) {
      opts = opts || {};
      var c = { treatment: opts.treatment || '', machine: !!opts.machine, treatmentPabau: '', clinic: opts.clinic ? clinicByValue(opts.clinic) : null, clinicPabau: '', linkPabau: '', location: opts.location || 'script' };
      open(c);
    },
    close: close,
    destinations: function (c) { return destinations(c || {}); }
  };

  /* ─── Theme editor ───────────────────────────────────────────────────── */
  /* The options are blocks the client reorders and edits (5 Oct), so in the
   * theme editor the panel opens when its section or one of its options is
   * selected, stays open while she edits it, and closes when she moves on.
   * Shown quietly: no tracking events from the editor. */

  function isOverlayEvent(event) {
    var t = event.target;
    if (!t || !t.querySelector) return false;
    return !!(t.querySelector('[data-booking-overlay]') || (t.closest && t.closest('[data-booking-overlay]')));
  }

  function editorContext() {
    return current || { treatment: '', machine: false, treatmentPabau: '', clinic: null, clinicPabau: '', linkPabau: '', location: 'editor' };
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wasOpen = isOpen && isOverlayEvent(event);
    if (wasOpen) { isOpen = false; lockPage(false); }
    init();
    if (wasOpen) open(editorContext(), true);
  });
  ['shopify:section:select', 'shopify:block:select'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (!isOverlayEvent(event)) return;
      root = document.querySelector('[data-booking-overlay]');
      open(editorContext(), true);
    });
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (isOverlayEvent(event)) close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
